// NOTE: Refer DsChip for DsTag Overrides
export const DsTagOverrides = {};
